<template>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  name: 'App',
  watch: {
    $route() {
      this.$store.commit("set", ["sidebarShow", false])
      this.$store.commit("set", ["eventLogDetailViewState", false])
    }
  },
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
